import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/ko';
import countryList from 'react-select-country-list';
import ReactCountryFlag from 'react-country-flag';
import Modal from 'react-modal';
import * as Icon from 'react-feather';

import axios from 'axios';
import { withTranslation, useTranslation } from 'react-i18next';

import VideoPlay from '../ExModal/VideoPlay';
import Config from '../../Config';

import Img1 from '../../assets/images/512_등록매뉴얼_이미지 복사.jpg';
import Img2 from '../../assets/images/512_부천이미지_참가등록 복사.jpg';
import Img3 from '../../assets/images/512_경북이미지_참가등록 복사.jpg';
import Img4 from '../../assets/images/img4.jpg';
import Img8 from '../../assets/images/img8.jpg';
import Img9 from '../../assets/images/img9.jpg';
import Icon7 from '../../assets/images/icon7.png';
import Icon8 from '../../assets/images/icon8.png';
import Icon9 from '../../assets/images/icon9.png';

if (localStorage.getItem('I18N_LANGUAGE_KPNP') === 'ENG') moment.locale('en');
else moment.locale('ko');

const modalStyles = {
  overlay: {
    position: '',
    top: 0,
    left: 0,
    // right: 0,
    bottom: 0,
    width: 0,
    backgroundColor: 'rgba(255, 255, 255, 0)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxHeight: '100%',
    maxWidth: '100%',
    width: '50%',
  },
};

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainEvent: null,
      recent: [],

      mainNews: [],
      mainNotice: [],
      mainVideo: [],
      mainImages: [],

      openModalVideo: false,
      videoUrl: '',
      videoType: '',

      settings: [],
      openModalView: false,
    };
  }

  componentDidMount() {
    this.getSettings();

    this.getMainEvent();
    this.getRecentEvent();

    this.getMainNews();
    this.getMainNotice();
    this.getMainVideo();
    this.getMainImages();
  }

  handleOpenModalVideo = () => {
    this.setState({ openModalVideo: true });
  };

  handleCloseModalVideo = () => {
    this.setState({ openModalVideo: false });
  };

  getSettings = async () => {
    try {
      let result = await axios.get(`${Config.authLambda}/settings`, {
        headers: {
          'x-access-token': this.props.authStatus
            ? this.props.profile.loggedInUser.accessToken
            : '',
          'content-type': 'application/json',
        },
      });
      if (result.data.type !== undefined && result.data.type === 'url') {
        const objectKey = result.data.key;
        result = await axios.get(result.data.url);

        await axios.post(`${Config.authLambda}/json`, {
          key: objectKey,
        });
      }

      this.setState({
        settings: result.data,
      });
      console.log(result.data);
    } catch (error) {
      const { data, status } = error.response;
      console.log(status);
      console.log(data);
      alert(data.message);
    }
  };

  getMainEvent = async () => {
    try {
      let result = await axios.get(`${Config.competitionLambda}/events/main`, {
        headers: {
          'x-access-token': this.props.authStatus
            ? this.props.profile.loggedInUser.accessToken
            : '',
          'content-type': 'application/json',
        },
      });
      if (result.data.type !== undefined && result.data.type === 'url') {
        const objectKey = result.data.key;
        result = await axios.get(result.data.url);

        await axios.post(`${Config.authLambda}/json`, {
          key: objectKey,
        });
      }

      this.setState({
        mainEvent: result.data,
      });
    } catch (error) {
      const { data, status } = error.response;
      console.log(status);
      console.log(data);
      alert(data.message);
    }
  };

  getMainNews = async () => {
    try {
      let result = await axios.get(`${Config.competitionLambda}/main/news`, {
        headers: {
          'x-access-token': this.props.authStatus
            ? this.props.profile.loggedInUser.accessToken
            : '',
          'content-type': 'application/json',
        },
      });
      if (result.data.type !== undefined && result.data.type === 'url') {
        const objectKey = result.data.key;
        result = await axios.get(result.data.url);

        await axios.post(`${Config.authLambda}/json`, {
          key: objectKey,
        });
      }

      this.setState({
        mainNews: result.data,
      });
    } catch (error) {
      const { data, status } = error.response;
      console.log(status);
      console.log(data);
      alert(data.message);
    }
  };

  getMainNotice = async () => {
    try {
      let result = await axios.get(`${Config.competitionLambda}/main/notice`, {
        headers: {
          'x-access-token': this.props.authStatus
            ? this.props.profile.loggedInUser.accessToken
            : '',
          'content-type': 'application/json',
        },
      });
      if (result.data.type !== undefined && result.data.type === 'url') {
        const objectKey = result.data.key;
        result = await axios.get(result.data.url);

        await axios.post(`${Config.authLambda}/json`, {
          key: objectKey,
        });
      }

      this.setState({
        mainNotice: result.data,
      });
    } catch (error) {
      const { data, status } = error.response;
      console.log(status);
      console.log(data);
      alert(data.message);
    }
  };

  getMainVideo = async () => {
    try {
      let result = await axios.get(`${Config.competitionLambda}/main/video`, {
        headers: {
          'x-access-token': this.props.authStatus
            ? this.props.profile.loggedInUser.accessToken
            : '',
          'content-type': 'application/json',
        },
      });
      if (result.data.type !== undefined && result.data.type === 'url') {
        const objectKey = result.data.key;
        result = await axios.get(result.data.url);

        await axios.post(`${Config.authLambda}/json`, {
          key: objectKey,
        });
      }

      this.setState({
        mainVideo: result.data,
      });
    } catch (error) {
      const { data, status } = error.response;
      console.log(status);
      console.log(data);
      alert(data.message);
    }
  };

  getMainImages = async () => {
    try {
      let result = await axios.get(`${Config.competitionLambda}/main/images`, {
        headers: {
          'x-access-token': this.props.authStatus
            ? this.props.profile.loggedInUser.accessToken
            : '',
          'content-type': 'application/json',
        },
      });
      if (result.data.type !== undefined && result.data.type === 'url') {
        const objectKey = result.data.key;
        result = await axios.get(result.data.url);

        await axios.post(`${Config.authLambda}/json`, {
          key: objectKey,
        });
      }

      this.setState({
        mainImages: result.data,
      });
    } catch (error) {
      const { data, status } = error.response;
      console.log(status);
      console.log(data);
      alert(data.message);
    }
  };

  getRecentEvent = async () => {
    try {
      let result = await axios.get(
        `${Config.competitionLambda}/events/recent`,
        {
          headers: {
            'x-access-token': this.props.authStatus
              ? this.props.profile.loggedInUser.accessToken
              : '',
            'content-type': 'application/json',
          },
        },
      );
      if (result.data.type !== undefined && result.data.type === 'url') {
        const objectKey = result.data.key;
        result = await axios.get(result.data.url);

        console.log(result);

        await axios.post(`${Config.authLambda}/json`, {
          key: objectKey,
        });
      }

      this.setState({
        recent: result.data,
      });
    } catch (error) {
      const { data, status } = error.response;
      console.log(status);
      console.log(data);
      alert(data.message);
    }
  };

  renderMainEvent = () => {
    let mainImage = Img4;
    let side1Image = Img1;
    let side2Image = Img2;
    let side3Image = Img3;

    let mainLink = '#';
    let side1Link = '/site/KTADYNAMIC_2023/application';
    let side2Link = '/site/210617/application';
    let side3Link =
      'https://s3.ap-northeast-2.amazonaws.com/kpnp-on.com/ext-video/2023+KTA+%EB%8B%A4%EC%9D%B4%EB%82%B4%EB%AF%B9%ED%83%9C%EA%B6%8C%EB%8F%84+%EB%8C%80%ED%9A%8C+%EC%B0%B8%EA%B0%80%EB%93%B1%EB%A1%9D+%EB%A7%A4%EB%89%B4%EC%96%BC.pdf';

    for (let index = 0; index < this.state.settings.length; index += 1) {
      const element = this.state.settings[index];

      if (element.key === 'SIDE_1_IMAGE_LINK') side1Link = element.value;
      else if (element.key === 'SIDE_1_IMAGE_PATH') side1Image = element.value;
      else if (element.key === 'SIDE_2_IMAGE_LINK') side2Link = element.value;
      else if (element.key === 'SIDE_2_IMAGE_PATH') side2Image = element.value;
      else if (element.key === 'SIDE_3_IMAGE_LINK') side3Link = element.value;
      else if (element.key === 'SIDE_3_IMAGE_PATH') side3Image = element.value;
      else if (element.key === 'MAIN_LINK') mainLink = element.value;
      else if (element.key === 'MAIN_IMAGE') mainImage = element.value;
    }

    if (this.state.mainEvent == null) {
      return (
        <ul>
          <li>
            {/* <div className="km">
              <div className="km_txt">
                <h2>2020 WORLD TAEKWONDO CHAMPIONSHIPS</h2>
                <p>Seoul Korea 20 December 2020</p>
              </div>
            </div> */}
          </li>
          <li>
            <ul>
              <li>
                <a href="#">
                  <img src={side1Image} alt="" />
                </a>
              </li>
              <li>
                <a href="#">
                  <img src={side2Image} alt="" />
                </a>
              </li>
              <li>
                <a href="#">
                  <img src={side3Image} alt="" />
                </a>
              </li>
            </ul>
          </li>
        </ul>
      );
    }

    const event = this.state.mainEvent;
    let image = event.mainImage;
    if (image === null) image = Img4;

    return (
      <ul>
        <li>
          <a href={mainLink}>
            <div
              className="km"
              style={{ backgroundImage: `url('${mainImage}')` }}
            >
              {/* <div className="km_txt">
              <h2>{event.title}</h2>
              <p>
                {`${countryList().getLabel(event.country)} `}
                <ReactCountryFlag countryCode={event.country} svg />
                {` ${moment(event.startDate).format('YYYY MMM Do, dddd')}`}{' '}
              </p>
            </div> */}
            </div>
          </a>
        </li>
        <li>
          <ul>
            <li>
              <a href={side1Link}>
                <img src={side1Image} alt="" />
              </a>
            </li>
            <li>
              <a href={side2Link}>
                <img src={side2Image} alt="" />
              </a>
            </li>
            <li>
              <a href={side3Link} target="_blank" rel="noreferrer">
                <img src={side3Image} alt="" />
              </a>
            </li>
          </ul>
        </li>
      </ul>
    );
  };

  renderRecentEvent = () => {
    const { t } = this.props;

    const events = this.state.recent;

    return events.map(event => {
      let image = event.competitionLogo;
      if (image === null) image = Img4;

      return (
        <li key={`key-recent-event-${event.id}`}>
          <Link as="a" to={`/competition/${event.code}`}>
            <div className="lc">
              <div className="lc_img">
                <img src={image} alt="" />
              </div>
              <div className="lc_txt">
                <div className="date">
                  <img src={Icon8} alt="" />{' '}
                  {moment(event.endDate).format('YYYY')}{' '}
                  {moment(event.endDate).format('MMMM')}{' '}
                  <span>{moment(event.startDate).format('D')}</span>{' '}
                  {moment(event.startDate).format('ddd')} -{' '}
                  <span>{moment(event.endDate).format('D')}</span>{' '}
                  {moment(event.endDate).format('ddd')}
                </div>
                <h2>
                  {/* <span className="green">DAY2</span> */}
                  {event.title}
                </h2>
                <div className="online">
                  <span>
                    <img src={Icon9} alt="" />
                    {event.locations != null
                      ? `${event.locations} | `
                      : ''}{' '}
                    {`${countryList().getLabel(event.country)} `}
                    <ReactCountryFlag countryCode={event.country} svg />
                  </span>
                </div>
              </div>
            </div>
          </Link>
          <div className="rc">
            <div className="more">
              <Link as="a" to={`/competition/${event.code}`}>
                {t('바로가기')}
              </Link>
            </div>
          </div>
        </li>
      );
    });
  };

  onPlayer = bbs => {
    this.setState({
      videoUrl: bbs.videoUrl,
      videoType: bbs.videoType,
    });
    this.handleOpenModalVideo();
  };

  renderNews = () => {
    const { mainNews } = this.state;

    return mainNews.map(item => {
      return (
        <li key={`key-recent-news-${item.id}`}>
          <div
            className="l_img"
            style={{ backgroundImage: `url('${item.file}')` }}
          />
          <div className="r_txt">
            <span>{moment(item.createdAt).format('YYYY MM DD')}</span>
            <h2>
              <Link as="a" to={`/competition/${item.event.code}/news`}>
                {item.title}
              </Link>
            </h2>
            <p>{item.content.replace(/(<([^>]+)>)/gi, ' ')}</p>
          </div>
        </li>
      );
    });
  };

  renderNotice = () => {
    const { mainNotice } = this.state;

    return mainNotice.map(item => {
      return (
        <li key={`key-recent-notice-${item.id}`}>
          {/* <div
            className="l_img"
            style={{ backgroundImage: `url('${item.file}')` }}
          /> */}
          <div className="r_txt" style={{ width: '100%' }}>
            <span>{moment(item.createdAt).format('YYYY MM DD')}</span>
            <h2>
              <Link as="a" to={`/competition/${item.event.code}/notice`}>
                {item.title}
              </Link>
            </h2>
            <p>{item.content.replace(/(<([^>]+)>)/gi, ' ')}</p>
          </div>
        </li>
      );
    });
  };

  renderVideo = () => {
    const { mainVideo } = this.state;

    if (mainVideo != null && mainVideo.length > 0) {
      const video = mainVideo[0];
      return (
        <a
          href="#"
          onClick={() => {
            this.onPlayer(video);
          }}
        >
          <img src={video.file} style={{ width: '100%' }} alt="" />
        </a>
      );
    }
    return (
      <a href="">
        <img src={Img8} alt="" />
      </a>
    );
  };

  renderImages = () => {
    const { mainImages } = this.state;

    if (mainImages != null && mainImages.length > 0) {
      const image = mainImages[0];

      return (
        <Link as="a" to={`/competition/${image.event.code}/photo`}>
          <ul className="mslider">
            <li style={{ backgroundImage: `url('${image.file}')` }} />
          </ul>
        </Link>
      );
    }
    return (
      <ul className="mslider">
        <li style={{ backgroundImage: `url('${Img9}')` }} />
      </ul>
    );
  };

  render() {
    const { t } = this.props;

    return (
      <div id="container">
        <div className="content">
          <div className="box1">{this.renderMainEvent()}</div>
        </div>

        <div className="box3">
          <span> </span>
          <h1>{t('진행(예정)대회')}</h1>
          <img src={Icon7} alt="" />
          <ul className="event_list">{this.renderRecentEvent()}</ul>
        </div>

        <div className="content">
          <div className="box2">
            <ul className="clm">
              <li className="com">
                <div className="con_top">
                  <h2>{t('커뮤니티')}</h2>
                  <div className="mcate">
                    <ul>
                      <li className="on">{t('공지사항')}</li>
                      {/* <li>공지사항</li> */}
                    </ul>
                  </div>
                </div>
                <div className="con_box news">
                  <ul className="cbu">{this.renderNotice()}</ul>
                </div>
              </li>
              <li className="lm">
                <ul>
                  <li>
                    <div className="con_top">
                      <h2>{t('대회영상')}</h2>
                    </div>
                    <div className="con_box">{this.renderVideo()}</div>

                    <VideoPlay
                      videoUrl={this.state.videoUrl}
                      videoType={this.state.videoType}
                      isOpen={this.state.openModalVideo}
                      onRequestClose={this.handleCloseModalVideo}
                    />
                  </li>
                  <li>
                    <div className="con_top">
                      <h2>{t('사진/미디어')}</h2>
                    </div>
                    <div className="con_box">{this.renderImages()}</div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <Modal
          isOpen={this.state.openModalView}
          onRequestClose={() => {
            this.setState({ openModalView: false });
          }}
          style={modalStyles}
          shouldCloseOnOverlayClick={false}
        >
          <div
            className="kcontent modal"
            style={{ width: 'auto', paddingBottom: 0 }}
          >
            <div className="close-btn">
              <Icon.X
                onClick={() => {
                  this.setState({ openModalView: false });
                }}
              />
            </div>
            <h2
              style={{
                fontSize: 'large',
                fontWeight: 'bold',
                margin: '0 0 20px',
                lineHeight: '40px',
              }}
            >
              2023 다이내믹 태권도 문의 전화번호 안내
            </h2>

            <div style={{ padding: 2, backgroundColor: '#ececec' }}>
              <div
                style={{
                  fontSize: 16,
                  padding: 10,
                  boxSizing: 'border-box',
                  backgroundColor: '#fff',
                  width: '100%',
                  height: '100%',
                  lineHeight: '1.6',
                }}
                className="news-modal-content"
              >
                안내드립니다.
                <br />
                <br />
                2023 다이내믹 태권도 등록접수관련 문의는 하기의 케이피앤피로
                전화 문의하여 주십시요.
                <br />
                <br />
                문의 전화번호: 02-563-5989
                <br />
                <br />
                감사합니다.
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withTranslation()(Main);
